var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09761 5.00732L2.81849 1.31982H17.1816L18.9025 5.00732H1.09761Z",
    stroke: "#393939"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 11.3198,
    width: 6.5,
    height: 9,
    rx: 0.875,
    stroke: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7594 5.79964C6.27412 6.98571 5.10888 7.81982 3.75 7.81982C2.39112 7.81982 1.22588 6.98571 0.740601 5.79964C0.668615 5.6237 0.70497 5.46784 0.825275 5.332C0.956683 5.18363 1.18773 5.06982 1.45503 5.06982H6.04497C6.31227 5.06982 6.54332 5.18363 6.67473 5.332C6.79503 5.46784 6.83138 5.6237 6.7594 5.79964Z",
    stroke: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0094 5.79964C12.5241 6.98571 11.3589 7.81982 10 7.81982C8.64112 7.81982 7.47588 6.98571 6.9906 5.79964C6.91862 5.6237 6.95497 5.46784 7.07527 5.332C7.20668 5.18363 7.43773 5.06982 7.70503 5.06982H12.295C12.5623 5.06982 12.7933 5.18363 12.9247 5.332C13.045 5.46784 13.0814 5.6237 13.0094 5.79964Z",
    stroke: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2594 5.79964C18.7741 6.98571 17.6089 7.81982 16.25 7.81982C14.8911 7.81982 13.7259 6.98571 13.2406 5.79964C13.1686 5.6237 13.205 5.46784 13.3253 5.332C13.4567 5.18363 13.6877 5.06982 13.955 5.06982H18.545C18.8123 5.06982 19.0433 5.18363 19.1747 5.332C19.295 5.46784 19.3314 5.6237 19.2594 5.79964Z",
    stroke: "#393939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17677 7.18346V19.4448C1.17677 20.2042 1.79238 20.8198 2.55177 20.8198H17.3753C18.1347 20.8198 18.7503 20.2042 18.7503 19.4448V7.18346H17.7503V19.4448C17.7503 19.6519 17.5824 19.8198 17.3753 19.8198H2.55177C2.34466 19.8198 2.17677 19.6519 2.17677 19.4448V7.18346H1.17677Z",
    fill: "#393939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.81982L7.5 1.44482",
    stroke: "#393939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.44482L13 5.81982",
    stroke: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.84df6c92d4911eacca486b4f37cefacf.svg";
export { ForwardRef as ReactComponent };